// Central brand asset references
export const LOGO_URL = "https://customer-assets-jai6qajn.emergentagent.net/job_offerforge-3/artifacts/n0j5hxv3_7167.jpg";
export const BRAND_NAME = "Moaglee";
export const BRAND_TAGLINE = "Commercial Real Estate";
